import { IRuleGroupService } from "../../service/evaluation/RuleGroupService";

export default class GetRuleGroupsInteractor {
  private ruleGroupService: IRuleGroupService;

  constructor(ruleGroupService) {
    this.ruleGroupService = ruleGroupService;
  }

  async execute() {
    return this.ruleGroupService.getRuleGroups();
  }
}
